import { useTranslation } from 'react-i18next';

import PlanSummary from './components/PlanSummary/PlanSummary';
import RadioCard from '../../../../../shared/components/Cards/RadioCard/RadioCard';
import type { ICommercialPlanBundle } from '../../../../../shared/interfaces/quotes';
import { TRANSLATIONS_QUOTES } from '../../../../../shared/translations/quotes';
import { formatCurrency } from '../../../../../shared/utils/currency/currency';
import PhaseHeader from '../../components/PhaseHeader/PhaseHeader';
import './PlanSelectionSection.scss';

interface IPlanSelectionSectionProps {
  bundles: ICommercialPlanBundle[];
  selectedBundleId: number | null;
  disabled?: boolean;
  locked?: boolean;
  onSelect: (bundleId: number) => void;
}

const PlanSelectionSection = ({
  bundles,
  selectedBundleId,
  disabled = false,
  locked = false,
  onSelect
}: IPlanSelectionSectionProps) => {
  const { t } = useTranslation();
  const title = t(TRANSLATIONS_QUOTES.create.planSelection.title);

  if (locked && bundles.length === 1) {
    return <PlanSummary bundle={bundles[0]} />;
  }

  return (
    <section className={`quote-plan-selection${disabled ? ' quote-plan-selection--disabled' : ''}`}>
      <PhaseHeader
        number="2"
        className="quote-plan-selection__header"
        title={title}
        status={selectedBundleId != null ? `✓ ${t(TRANSLATIONS_QUOTES.create.planSelection.selected)}` : undefined}
      />

      <div className="quote-plan-selection__cards" role="radiogroup" aria-label={title}>
        {bundles.map((bundle) => (
          <RadioCard
            key={bundle.id}
            selected={selectedBundleId === bundle.id}
            onSelect={disabled || locked ? undefined : () => onSelect(bundle.id)}
            label={
              <div className="quote-plan-selection__card-main">
                <div className="quote-plan-selection__card-text">
                  <span className="quote-plan-selection__card-name">{bundle.name}</span>
                  <p className="quote-plan-selection__card-summary">{bundle.description}</p>
                </div>
                <span className="quote-plan-selection__card-price">
                  <span className="quote-plan-selection__card-price-amount">
                    {bundle.suggestedPrice != null ? formatCurrency(bundle.suggestedPrice) : '—'}
                  </span>
                  <span className="quote-plan-selection__card-price-unit">
                    {t(TRANSLATIONS_QUOTES.create.planSelection.perEmployee)}
                  </span>
                </span>
              </div>
            }
          />
        ))}
      </div>
    </section>
  );
};

export default PlanSelectionSection;
